/**
 * Os bundles da loja são servidos em /_loja/ (App.ts: express.static de
 * dist_loja), mas o EJS injeta os <script> manualmente — o webpack não sabe
 * de onde veio e buscaria chunks lazy a partir da raiz (404).
 *
 * Este arquivo precisa ser o PRIMEIRO import do main.ts: define o publicPath
 * em runtime para os chunks lazy (ex.: o widget da Mia) carregarem do lugar certo.
 */
declare let __webpack_public_path__: string;
__webpack_public_path__ = '/_loja/';
